export default __webpack_public_path__ + "static/media/640_store05-it-web.fed1a308.png";